export * from './padraodeoperacao-edit.component';
export * from './padraodeoperacao-browse.component';